import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../../handleRequestThunk';
import { getPartsNoAccountList } from '../partsThunks';
import { commonInitialState } from '../../../../../utils/common/commonInitialState';
const SLICE_NAME = 'partsNoAccountList';

export const partsNoAccountListSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getPartsNoAccountList });
    },
});

export const partsNoAccountList = partsNoAccountListSlice.reducer;
